import { useState } from "react";
import { Instagram, Download, X } from "lucide-react";
import { Button } from "./ui/button";

function wrapText(ctx, text, x, y, maxW, lh) {
  const words = (text || "").split(" ");
  let line = "", yy = y;
  for (const w of words) {
    const test = line + w + " ";
    if (ctx.measureText(test).width > maxW && line) { ctx.fillText(line.trim(), x, yy); line = w + " "; yy += lh; }
    else line = test;
  }
  ctx.fillText(line.trim(), x, yy);
  return yy;
}

export const StoryShare = ({ truck }) => {
  const [img, setImg] = useState(null);
  const [open, setOpen] = useState(false);

  const generate = async () => {
    try { await document.fonts.ready; } catch (e) { console.warn("fonts.ready unavailable", e); }
    const c = document.createElement("canvas");
    c.width = 1080; c.height = 1920;
    const x = c.getContext("2d");
    x.fillStyle = "#0E3F5B"; x.fillRect(0, 0, 1080, 1920);
    x.fillStyle = "#FF9F1C"; x.beginPath(); x.arc(900, 280, 340, 0, Math.PI * 2); x.fill();
    x.fillStyle = "rgba(46,196,182,0.22)"; x.beginPath(); x.arc(160, 1680, 300, 0, Math.PI * 2); x.fill();

    x.textAlign = "left";
    x.font = "800 66px 'Baloo 2', sans-serif";
    x.fillStyle = "#ffffff"; x.fillText("Streat", 90, 210);
    const w = x.measureText("Streat").width;
    x.fillStyle = "#FF9F1C"; x.fillText("Eat", 90 + w, 210);

    x.font = "700 54px 'Baloo 2', sans-serif"; x.fillStyle = "#2EC4B6";
    x.fillText(truck.name, 90, 600);

    x.font = "700 40px 'Baloo 2', sans-serif"; x.fillStyle = "#FF9F1C";
    x.fillText("AUJOURD'HUI, ON EST À", 90, 720);

    const loc = truck.today_location || {};
    x.font = "800 118px 'Baloo 2', sans-serif"; x.fillStyle = "#ffffff";
    const endY = wrapText(x, loc.label || truck.city, 90, 850, 900, 122);

    x.font = "400 40px 'Inter', sans-serif"; x.fillStyle = "rgba(255,255,255,0.85)";
    if (loc.address) x.fillText(loc.address, 90, endY + 90);

    const d = new Date().toLocaleDateString("fr-FR", { weekday: "long", day: "numeric", month: "long" });
    x.font = "700 46px 'Baloo 2', sans-serif"; x.fillStyle = "#FF9F1C";
    x.fillText(d.charAt(0).toUpperCase() + d.slice(1), 90, endY + 180);

    x.font = "600 38px 'Inter', sans-serif"; x.fillStyle = "rgba(255,255,255,0.7)";
    x.fillText(truck.cuisine, 90, endY + 250);

    x.font = "700 42px 'Baloo 2', sans-serif"; x.fillStyle = "#ffffff";
    x.fillText("Retrouvez-nous sur StreatEat", 90, 1790);
    x.font = "400 34px 'Inter', sans-serif"; x.fillStyle = "rgba(255,255,255,0.6)";
    x.fillText("streateat · /foodtruck/" + truck.slug, 90, 1840);

    setImg(c.toDataURL("image/png"));
    setOpen(true);
  };

  const download = () => { const a = document.createElement("a"); a.href = img; a.download = `${truck.slug}-story.png`; a.click(); };

  return (
    <>
      <Button onClick={generate} variant="outline" className="w-full rounded-full border-coral-twist/40 text-coral-twist font-bold gap-2 hover:bg-coral-twist/5" data-testid="story-share-btn">
        <Instagram size={16} /> Story Instagram
      </Button>
      {open && (
        <div className="fixed inset-0 bg-urban-teal/60 backdrop-blur-sm flex items-center justify-center z-50 p-4" onClick={() => setOpen(false)} data-testid="story-modal">
          <div className="bg-white rounded-3xl p-5 max-w-sm w-full" onClick={(e) => e.stopPropagation()}>
            <div className="flex items-center justify-between mb-3">
              <p className="font-display font-bold text-urban-teal">Votre story est prête !</p>
              <button onClick={() => setOpen(false)} className="text-urban-teal/50"><X size={20} /></button>
            </div>
            <img src={img} alt="Story" className="w-full rounded-2xl max-h-[60vh] object-contain bg-cream-bg" />
            <Button onClick={download} className="w-full rounded-full bg-street-gold hover:bg-street-gold/90 text-white font-bold mt-4 gap-2" data-testid="story-download-btn"><Download size={16} /> Télécharger l'image</Button>
          </div>
        </div>
      )}
    </>
  );
};
